import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

export const BorderButton = styled(Button)(
  ({ minHeight = "45px", ...props }) => `
  background: white;
  border: 1px solid ${props.theme.palette.primary.main};
  text-transform: none;
  min-height: ${minHeight}
  border-radius: 0px !important;
  width: 100%;
  font-weight: 600;
  font-size: 16px;
  line-height: normal;
  color: ${props.theme.palette.primary.main};
  box-shadow: none;

  &:hover {
    background-color: ${props.theme.palette.primary.main};
    color: white;
  }
`
);
